import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authAPI } from '../services/api';
import ChangePasswordModal from './Auth/ChangePasswordModal';
import './NavigationDrawer.css';

function NavigationDrawer({ user, onLogout, isOpen, onToggle }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [deviceInfo, setDeviceInfo] = useState(null);
  const [ipAddress, setIpAddress] = useState(null);

  const menuItems = [
    {
      path: '/dashboard',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
      label: 'Dashboard',
      description: 'Home'
    },
    {
      path: '/customers',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
      label: 'Customers',
      description: 'Manage customers'
    },
    
    {
      path: '/orders',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>,
      label: 'Orders',
      description: 'Manage orders'
    },
    {
      path: '/deliveries',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
      label: 'Deliveries',
      description: 'Manage deliveries',
      children: [
        {
          path: '/deliveries/runs',
          icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
          label: 'Delivery Diary',
          description: 'Every delivery run, by date'
        },
        {
          path: '/deliveries/planning',
          icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
          label: 'Delivery Run Planning',
          description: 'Plan delivery runs'
        },
        {
          path: '/deliveries/vehicles',
          icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 17h4V5H2v12h3"/><path d="M20 17h2v-3.34a4 4 0 0 0-1.17-2.83L19 9h-5v8h1"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>,
          label: 'Vehicle Availability',
          description: 'Manage vehicle availability'
        }
      ]
    },
    {
      path: '/reports',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
      label: 'Reports',
      description: 'Coming soon',
      disabled: true,
      hidden: true
    }
  ];

  // Admin menu items (only shown to administrators)
  const adminMenuItems = [
    {
      path: '/admin',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
      label: 'Admin Dashboard',
      description: 'System overview'
    },
    {
      path: '/customer-fields',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
      label: 'Custom Fields',
      description: 'Configure fields'
    },
    {
      path: '/products',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
      label: 'Products',
      description: 'Manage products'
    },
    {
      path: '/admin/users',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
      label: 'User Management',
      description: 'Manage users'
    },
    {
      path: '/admin/logs',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
      label: 'Auth Logs',
      description: 'View logs'
    },
    {
      path: '/admin/webhooks',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>,
      label: 'Webhooks',
      description: 'Manage webhooks'
    },
    {
      path: '/admin/backups',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/><path d="M16 21h5v-5"/></svg>,
      label: 'Backups',
      description: 'Manage backups'
    }
  ];

  const [expandedMenus, setExpandedMenus] = useState({});
  const [showChangePassword, setShowChangePassword] = useState(false);

  const handleNavigation = (path, disabled) => {
    if (!disabled) {
      navigate(path);
    }
  };

  const toggleExpand = (path) => {
    setExpandedMenus(prev => ({
      ...prev,
      [path]: !prev[path]
    }));
  };

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  useEffect(() => {
    // Fetch full user data including device info
    const fetchUserData = async () => {
      try {
        const response = await authAPI.getMe();
        setDeviceInfo(response.device);
        setIpAddress(response.current_ip);
      } catch (err) {
        console.error('Error fetching user data:', err);
      }
    };

  fetchUserData();

  }, []);

  return (
    <>
      <div className={`navigation-drawer ${isOpen ? 'open' : 'closed'}`}>
        <div className="drawer-header">
          <button className="drawer-toggle" onClick={onToggle} title={isOpen ? 'Collapse menu' : 'Expand menu'}>
            {isOpen ? '◀' : '▶'}
          </button>
          {isOpen && <h2>Menu</h2>}
        </div>

        <nav className="drawer-nav">
          {menuItems.map((item) => {
            if (item.hidden) return null;
            return (
              <div key={item.path} className="nav-item-wrapper">
              <button
                className={`nav-item ${isActive(item.path) ? 'active' : ''} ${item.disabled ? 'disabled' : ''}`}
                onClick={() => item.children ? toggleExpand(item.path) : handleNavigation(item.path, item.disabled)}
                disabled={item.disabled}
                title={isOpen ? '' : item.label}
              >
                <span className="nav-icon">{item.icon}</span>
                {isOpen && (
                  <div className="nav-text">
                    <span className="nav-label">{item.label}</span>
                    <span className="nav-description">{item.description}</span>
                  </div>
                )}
                {isOpen && item.children && (
                  <span className="nav-expand-icon">
                    {expandedMenus[item.path] ? '▼' : '▶'}
                  </span>
                )}
              </button>
              {isOpen && item.children && expandedMenus[item.path] && (
                <div className="nav-children">
                  {item.children.map((child) => (
                    <button
                      key={child.path}
                      className={`nav-item nav-child-item ${isActive(child.path) ? 'active' : ''} ${child.disabled ? 'disabled' : ''}`}
                      onClick={() => handleNavigation(child.path, child.disabled)}
                      disabled={child.disabled}
                      title={isOpen ? '' : child.label}
                    >
                      <span className="nav-icon">{child.icon}</span>
                      <div className="nav-text">
                        <span className="nav-label">{child.label}</span>
                        <span className="nav-description">{child.description}</span>
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>
            );
          })}

          {/* Admin section - only visible to administrators */}
          {user.is_admin && (
            <>
              {isOpen && <div className="nav-divider">Administration</div>}
              {adminMenuItems.map((item) => (
                <button
                  key={item.path}
                  className={`nav-item ${isActive(item.path) ? 'active' : ''} ${item.disabled ? 'disabled' : ''}`}
                  onClick={() => handleNavigation(item.path, item.disabled)}
                  disabled={item.disabled}
                  title={isOpen ? '' : item.label}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {isOpen && (
                    <div className="nav-text">
                      <span className="nav-label">{item.label}</span>
                      <span className="nav-description">{item.description}</span>
                    </div>
                  )}
                </button>
              ))}
            </>
          )}
        </nav>

        <div className="drawer-footer">
          {isOpen && (
            <div className="user-profile">
              <div className="user-avatar">{user.username.charAt(0).toUpperCase()}</div>
              <div className="user-details">
                  <p>
                    Logged in as <strong>{user.username}</strong>
                    {ipAddress && <> from <strong>{ipAddress}</strong></>}
                    {deviceInfo && <> on device <strong>#{deviceInfo.id}</strong></>}
                </p>
              </div>
            </div>
          )}
          {isOpen && (
            <button
              className="change-password-link"
              onClick={() => setShowChangePassword(true)}
            >
              Change password
            </button>
          )}
          <button className="logout-button" onClick={onLogout} title={isOpen ? '' : 'Logout'}>
            <svg className="logout-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
            {isOpen && <span>Logout</span>}
          </button>
        </div>
      </div>
      
      {/* Overlay for mobile */}
      {isOpen && (
        <div className="drawer-overlay" onClick={onToggle}></div>
      )}

      <ChangePasswordModal
        isOpen={showChangePassword}
        onClose={() => setShowChangePassword(false)}
        user={user}
      />
    </>
  );
}

export default NavigationDrawer;
